import { useCallback, useMemo } from "react";
import { useLocation } from "react-router";
import { isAndroid, isIOS, isMobile, osVersion, mobileModel } from "react-device-detect";
import {
    isWebview,
    getPlatForm,
    inAppStore,
    inAppPlayStore,
    getAppVersion,
    goLogin,
    popupSubscriptionMobileInPostBody,
    getSysType,
    setClickLogapi,
    getProfileImage2,
} from "helpers";
import { toastr } from "components/toastr";
import { useSelector } from "react-redux";
import { POINT_DOMAIN, APP_SCHEME, OLD_STATION_DOMAIN } from "constant/config";

const WEB = 0;
const MOBILE_WEB = 1;
const ANDROID = 2;
const IOS = 3;

export const useDivertHiddenFunc = () => {
    // url hash parameter
    const { search = "", hash = "" } = useLocation();
    const platform = getPlatForm() || "";
    const { user_id } = useSelector((state) => state.authenticationReducer);

    // make URL param
    const bWebview = isWebview;
    const nDevice = isIOS ? 1 : isAndroid ? 2 : 0;
    const szVersion = getAppVersion();
    // 웹뷰가 아니면 기본 값 web
    const szModel = bWebview ? mobileModel : "web";
    const szOsVer = bWebview ? osVersion : "web";
    const sysType = bWebview ? "app" : isMobile ? "webm" : "web";
    const locaitonHash = new RegExp("#location_(\\w*)", "i");
    const location = locaitonHash.test(hash) ? locaitonHash.exec(hash)[1] : "station";
    const store = inAppStore() || "";
    const lang = document.documentElement.lang;

    const isLogin = useSelector(({ authenticationReducer }) => authenticationReducer.is_login);

    const checkAppWeb = useMemo(() => {
        if (isMobile) {
            // 모웹 1
            if (bWebview) {
                if (isAndroid) return ANDROID;
                if (isIOS) return IOS;
            }
            return MOBILE_WEB;
        }

        // web
        return WEB;
    }, [bWebview]);

    // encrypt func call

    // 채널 외부 브라우저 파라미터 추가
    /*const makeUrl = useCallback((redirectUrl) => {
            
        let url = '';
        if (redirectUrl.includes("?")){
            const domin = redirectUrl.split("?");
            url += domin[0];
            const params = domin[1].split("&");
            for (var i=0; i< params.length; i+2) {
                url += params[i] + "=" + params[i+1];
            }
        }

        return url;
    }, []);*/

    // 결제 페이지 URL
    const makePaymentURL = useCallback(
        (szWork = "", szKind = "", szApp = "", broadno = "") => {
            let url = "";
            url += "ndevice=" + nDevice;
            url += "&szWork=" + szWork + "&szKind=" + szKind;
            url += "&szUserID=" + user_id;
            url += "&szVersion=" + szVersion + "&szApp=" + szApp;
            url += "&szModel=" + szModel + "&szOsVer=" + szOsVer + "&broadno=" + broadno;
            url += "&sys_type=" + sysType + "&location=" + location;
            url += "&store=" + store + "&lang=" + lang + "&viewtype=";
            return url;
        },
        [lang, location, nDevice, store, sysType, szModel, szOsVer, szVersion, user_id],
    );

    // 채널 외부 브라우저 파라미터 추가
    const externalCommon = useCallback(
        (redirectUrl) => {
            let url = redirectUrl;
            if (!url.includes("php?")) {
                url += "?";
            }

            //url += "nDevice="+nDevice;
            url += makePaymentURL();

            switch (checkAppWeb) {
                case WEB:
                    window.open(url, "", "width=700px,height=800px,scrollbars=yes");
                    break;
                case MOBILE_WEB:
                    window.open(url, "_blank");
                    break;
                case ANDROID:
                case IOS:
                    //url += "&store="+store;
                    if (inAppPlayStore() == "Y" || store === "P" || isIOS) {
                        toastr.info("ios/구글 플레이스토어 앱 환경에서는\n 참여하실 수 없습니다.", {
                            timeOut: 5000,
                        });
                        return;
                    }
                    window.location.href = `${APP_SCHEME}browser/external?url=${encodeURIComponent(url)}`;
                    break;
                default:
                    break;
            }
        },
        [checkAppWeb, makePaymentURL, store],
    );

    // 별풍선 자동 충전 이벤트 call 분기 처리
    const starballoonAutoCharging = useCallback(
        (redirectUrl) => {
            // 비로그인 체크 및 로그인 페이지 이동
            if (isLogin === false) {
                goLogin();
                return false;
            }

            // Case1. 정상 동작 처리
            // 모웹 - 새탭, 원/갤 앱 - 외부 브라우저
            let url = "";

            // 모바일
            if (isMobile) {
                url = POINT_DOMAIN + "/SetMobileBalloonAutoPay.asp?";
                url += "ndevice=" + nDevice;
                url += "&szWork=help&szKind=TBOX20131007000000";
                url += "&szUserID=" + user_id;
                url += "&szVersion=" + szVersion + "&szApp=mafreecatv";
                url += "&szModel=" + szModel + "&szOsVer=" + szOsVer + "&broadno=&broad_no=";
                url += "&sys_type=" + sysType + "&location=" + location;
                url += "&store=" + store + "&lang=" + lang + "&viewtype=";

                // Case1(정상) a. 모웹
                if (!bWebview) {
                    window.open(url, "_blank");
                }

                if (isAndroid && bWebview) {
                    // Case2. 안드로이드 구글플레이스토어 호출
                    if (inAppPlayStore() == "Y" || store === "P") {
                        toastr.info("구글 플레이 스토어에서 받으신 앱에서는\n 별풍선 자동충전을 설정할 수 없습니다.", {
                            timeOut: 5000,
                        });
                        return;
                    }

                    // Case1(정상) b. p: playstore, o: onestore, s: galaxy
                    if (store === "O" || store === "S") {
                        window.location.href = `${APP_SCHEME}browser/external?url=${encodeURIComponent(url)}`;
                    }
                }

                // Case3. iOS alert 노출
                if (isIOS && bWebview) {
                    toastr.info("별풍선 자동충전은 PC 또는 모바일 웹에서 설정하실 수 있습니다.", {
                        timeOut: 5000,
                    });
                }
            } else {
                // PC 일 경우
                /**
                 * sys_type: 웹뷰 app,아니면 web
                 * location: #location_value (채널 이벤트 게시글 호출 시 추가 파라미터)
                 */
                url =
                    POINT_DOMAIN +
                    "/SetBalloonAutoPay.asp?nDevice=" +
                    nDevice +
                    "&autopaytype=3&sys_type=web&location=" +
                    location +
                    "&os=win";
                window.open(url, "별풍선 자동 충전", "width=700px,height=800px,scrollbars=yes");
            }
        },
        [bWebview, isLogin, lang, location, nDevice, store, sysType, szModel, szOsVer, szVersion, user_id],
    );

    // a 태그에 ppv 인앱결제 히든키워드 작성된 경우, index.html 에서 //static.m.afreecatv.com/js/app/lib/afreeca.link.js 호출
    const ppvEvent = useCallback((redirectUrl) => {
        const ppvRegExKeyword = /([\w\:\/\.]*.+).(sku\=([\w]*)+)/i;
        const ppvMatchList = ppvRegExKeyword.exec(redirectUrl);

        //ppvMatchList[0] : AFREECA::LINK_ADMIN(https://link.afreecatv.com/eventid&sku=ppv33)
        //ppvMatchList[1] : https://link.afreecatv.com/eventid
        //ppvMatchList[2] : sku=ppv33
        //ppvMatchList[3] : ppv33
        //정규식 그룹화 통과 시 배열 길이 3 이상이므로 길이 조건, 통과 못할 경우 결과가 null 또는 0 이므로 ppv 스킴주소 체크 제외
        if (ppvMatchList && ppvMatchList.length >= 3) {
            const ppvCheckUrl = "link.afreecatv.com";
            const ppvCheckParam = "sku";

            // link.afreecatv.com , sku 파람 값을 가지고 있을 때만 함수 호출, 없으면 약속된 형식이 아니므로 종료
            if (ppvMatchList[1].indexOf(ppvCheckUrl) !== -1 && ppvMatchList[2].indexOf(ppvCheckParam) !== -1) {
                const ppvParamUrl = ppvMatchList[1];
                const ppvParamSku = ppvMatchList[3];

                window.afreeca.link.browserIap(ppvParamUrl, ppvParamSku);
            } else {
                return;
            }
        }
    }, []);

    const soopiSubscription = useCallback((redirectUrl) => {
        let extractedBjId = "";
        let extractedBjNick = "";
        if (redirectUrl) {
            // URL에서 쿼리 파라미터 부분 추출
            const queryParamIndex = redirectUrl.indexOf("?");
            if (queryParamIndex !== -1) {
                const queryParams = redirectUrl.substring(queryParamIndex + 1);

                // 쿼리 파라미터들을 분리
                const params = queryParams.split("&");

                // bj_id 파라미터 찾기
                for (const param of params) {
                    const [key, value] = param.split("=");
                    if (key === "bj_id") {
                        extractedBjId = value;
                    } else if (key === "bj_nick") {
                        extractedBjNick = value;
                    }
                }
            }
        }

        if (!extractedBjId) return;

        if (!isWebview) {
            // 웹
            window.open(
                `${OLD_STATION_DOMAIN}/app/gift_subscription.php?bjId=${extractedBjId}&sysType=${getSysType()}&location=station`,
                "gift_popup",
                "width=320,height=240,scrollbars=yes",
            );
        } else {
            popupSubscriptionMobileInPostBody({
                bj_id: extractedBjId,
                bj_nick: extractedBjNick,
                bj_profile_image: getProfileImage2(extractedBjId, "WEBP_SMALL", ""),
            });
        }
        setClickLogapi("soopi_front", {
            button_type: `soopi_event_streamer_icon`,
            location: "station",
            bj_id: extractedBjId,
        });
    }, []);

    return useMemo(
        () => ({
            externalCommon,
            starballoonAutoCharging,
            ppvEvent,
            soopiSubscription,
        }),
        [externalCommon, starballoonAutoCharging, ppvEvent, soopiSubscription],
    );
};

export default useDivertHiddenFunc;

